<template>
  <div class="container-trigger">
    <div>
      <p><strong>{{ $t('nome-do-indicador') + ":"}} </strong> {{indicator}}</p>
      <div class="ranges">
        <div class="range">
          <p class="first">{{ $t('range') + "*" }}</p>
          <div>
            <div>
              <label for="critical-range"><strong>{{ $t('critico') }}</strong></label>
              <b-form-input id="critical-range" @change="updateRange" v-model="criticalRange" size="sm" type="number" min="0" max="101"></b-form-input>
            </div>
            <div>
              <label for="operating-range"><strong>{{ $t('operacao-0') }}</strong></label>
              <b-form-input id="operating-range" @change="updateRange" v-model="operatingRange" size="sm" type="number" min="0" max="101"></b-form-input>
            </div>
          </div>
        </div>
  
        <div class="range">
          <p>{{ $t('aderencia-0') + "*" }}</p>
          <div>
            <div>
              <label for="critical-threshold"><strong>{{ $t('critica') }}</strong></label>
              <b-form-input id="critical-threshold" @change="updateRange" v-model="reliabilityCritical" size="sm" type="number" min="0" max="101"></b-form-input>
            </div>
            <div>
              <label for="operating-threshold"><strong>{{ $t('meta-1') }}</strong></label>
              <b-form-input id="operating-threshold" @change="updateRange" v-model="reliabilityThreshold" size="sm" type="number" min="0" max="101"></b-form-input>
            </div>
          </div>
        </div>
      </div>

      <div class="trigger-options mt-3">
        <p>{{ $t('configuracao-de-identificacao') }}</p>
        <div>
          <label for="process-list"><strong>{{ $t('processos-0') + "*:" }}</strong></label>
          <b-form-select id="process-list" v-if="processList.length > 1" v-model="processSelected" :options="processList" size="sm"></b-form-select>
          <label class="no-content" v-else>{{ $t('nao-foi-encontrado-processos-cadastrado-no-sistema') }}</label>
        </div>
        <div>
          <label for="product-list"><strong>{{ $t('produto-0') + ":"}}</strong></label>
          <b-form-select v-if="productList.length > 1" id="product-list" v-model="productSelected" :options="productList" size="sm"></b-form-select>
          <label class="no-content" v-else>{{ $t('nao-foi-encontrado-produtos-cadastrado-no-sistema') }}</label>
        </div>
        <div>
          <label for="equipment-list"><strong>{{ $t('equipamento-0') }}</strong></label>
          <b-form-select id="equipment-list" v-if="equipmentList.length > 1" v-model="equipmentSelected" :options="equipmentList" size="sm"></b-form-select>
          <label class="no-content" v-else>{{ $t('nao-foi-encontrado-equipamentos-cadastrado-no-sistema') }}</label>
        </div>
        <b-button v-if="newtrigger" 
          id="add-trigger-config"
          :title="$t('inserir-configuracao')" 
          size="sm" 
          class="button-pentagro mt-1 btn-add-configuration" 
          @click="addTriggerConfig">
          <b-icon class="mr-2" icon="plus-circle"></b-icon>
          {{ $t('adicionar-grupo-de-gatilhos') }} </b-button>
      </div>
      <b-card no-body header="Grupo de Gatilhos" class="configured-trigger mt-2">
        <b-list-group v-if="triggersConfigList.length" flush>
          <b-list-group-item 
            v-for="trigger, index in triggersConfigList" :key="index"
            :class="{'config-list': true, 'selected': trigger == triggerConfigSelected}"
            @click="selectTriggerConfig(trigger)"
            href="#">{{trigger}} <span class="remove-config" :title="$t('remover-configuracao')" @click="removeConf(trigger)">x</span></b-list-group-item>
        </b-list-group>
        <b-list-group v-else flush>
          <b-list-group-item href="#" disabled>{{ $t('nao-ha-grupo-de-gatilhos-configurados') }}</b-list-group-item>
        </b-list-group>
      </b-card>
    </div>
    <TriggerConfiguration />
  </div>
</template>

<script>
import { showError } from '../../../../../global';
import Mediator from '../../utilities/Mediator';
import MediatorTrigger from './MediatorTrigger';
import TriggerConfiguration from "./triggers/TriggersConfiguration.vue"

export default {
  name: "Manage-Trigger",

  components: { TriggerConfiguration },

  data() {
    return {
      indicator: "",
      step: "step-5",
      nextStep: "step-6",

      operatingRange: 4,
      criticalRange: 5,
      reliabilityThreshold: 70,
      reliabilityCritical: 60,

      processSelected: null,
      processList: [{value: null, text: this.$t('selecione-um-processo'), disabled: true}],

      productSelected: null,
      productList: [{value: null, text: this.$t('selecione-um-produto') }],

      equipmentSelected: null,
      equipmentList: [{value: null, text: this.$t('selectAEquipment')}],

      newtrigger: true,
      triggersConfigList: [],
      triggerConfigSelected: null,
      removingConfig: false
    }
  },

  methods: {
    updateRange(){
      if(this.operatingRange == 0 || this.criticalRange == 0){
        showError(this.$t('e-necessario-configurar-os-ranges-do-gatilho'));
        return
      }

      if(parseInt(this.operatingRange) > parseInt(this.criticalRange)){
        showError(this.$t('range-de-operacao-precisar-ser-menor-ou-igual-ao-range-critico'));
        return
      }

      if(parseInt(this.reliabilityThreshold) < parseInt(this.reliabilityCritical)){
        showError(this.$t('aderencia-meta-precisa-ser-maior-ou-igual-ao-aderencia-critica'));
        return
      }

      Mediator.notify(this, "update-ranges")
    },

    init(){
      MediatorTrigger.notify(this, "init-triggers")
      this.indicator = Mediator.indicator.indicatorName
      this.operatingRange = Mediator.indicator.operatingRange
      this.criticalRange = Mediator.indicator.criticalRange
      this.reliabilityThreshold = Mediator.indicator.reliabilityThreshold
      this.reliabilityCritical = Mediator.indicator.reliabilityCritical

      this.triggersConfigList = new Array()
      for (const ids of Mediator.triggers.triggersConfigMap.keys()) {
        let split = ids.split("-")
        let result = this.setTriggerConfig(split[0], split[1], split[2])

        this.triggersConfigList.push(result)
      }
      this.triggersConfigList.sort((a,b) => a>b?1:b>a?-1:0)
    },

    addTriggerConfig(){
      try{
        this.validForm()
      }
      catch(e){
        showError(e)
        return
      }

      let result = this.setTriggerConfig(this.processSelected, this.productSelected, this.equipmentSelected)

      if(this.triggersConfigList.includes(result)){
        showError(`${this.$t('configuracao-0')} ${result} ${this.$t('ja-inserida')}`)
        return 
      }
      
      this.triggersConfigList.push(result)
      this.triggersConfigList.sort((a,b) => a>b?1:b>a?-1:0)
      Mediator.notify(this, "update-step-5")
      setTimeout(() => {
        this.processSelected= null;
        this.productSelected= null;
        this.equipmentSelected = null;
      }, 500);
    },

    setTriggerConfig(processId, productId, equipmentId){
      var getText = (array = new Array()) =>{
        return array.map(p => p.text)[0]
      } 

      let process = getText(this.processList.filter(p => p.value == processId))
      let product = getText(this.productList.filter(p => productId && p.value == productId))
      let equipment = getText(this.equipmentList.filter(p => equipmentId && p.value == equipmentId))
      let result = `${process}`
      result += product ? ` / ${product}` : ""
      result += equipment ? ` / ${equipment}` : ""

      return result;
    },

    validForm(){
      if(this.reliabilityThreshold == 0 || this.reliabilityCritical == 0)
        throw this.$t('e-necessario-configurar-as-aderencias-do-gatilho');
      if(!this.processSelected)
        throw this.$t('e-necessario-selecionar-um-processo');
    },

    selectTriggerConfig(triggerConfig){
      if(this.removingConf || !triggerConfig) return
      this.triggerConfigSelected = triggerConfig
      MediatorTrigger.notify(triggerConfig, "select-trigger-config")
    },

    removeConf(trigger){
      this.removingConf = true;
      let index =this.triggersConfigList.indexOf(trigger)
      this.triggersConfigList.splice(index, 1)
      MediatorTrigger.notify(trigger, "remove-trigger-config")
      setTimeout(() => {
        this.removingConf = false;
      }, 150);
    }
  },

  mounted() {
    Mediator.notify(this, "init-step")
    setTimeout(() => {
      this.init()
    }, 100)
  }
}
</script>

<style scoped>

.container-trigger{
  display: grid;
  grid-template-columns: 38.2% 61.8%;
  gap: 8px;
  height: 69vh;
  width: 100%;
}
.container-trigger>div{
  display: flex;
  flex-direction: column;
  height: inherit;
  width: 100%;
  background-color: #00000005;
  box-shadow: 0 0 3px #00000018;
  border-radius: 4px;
  margin: 3px 0;
}

.container-trigger>div:first-child{
  padding: 0 8px;
}

.container-trigger>div:last-child{
  padding: 0 0 0 8px;
}

.range{
  display: flex;
  flex-direction: column;
}

.range,
.trigger-options{
  border: 1px solid #00000020;
  border-radius: 4px;
  padding: 4px;
}

.range,
.trigger-options{
  border: 1px solid #00000020;
  border-radius: 4px;
  padding: 4px;
}

.range > p,
.trigger-options > p{
  position: relative;
  padding: 2px 4px 0px 4px ;
  width: 11.5rem;
  top: -17px;
  margin-bottom: -17px;
  background-color: #fbfbfb;
  box-shadow: 0 0 5px #fbfbfb;
  font-size: 0.8rem;
  text-align: center;
  border-radius: 2px;
  font-weight: 600;
}

.range strong,
.trigger-options strong{
  font-weight: 400;
}

.range > p{
  text-align: start;
  width: 4.5rem;
}

.range > p.first{
  width: 3rem;
}

.ranges,
.range > div,
.trigger-options > div{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0 0 0;
}

.ranges>div{
  width: 48%;
}

.range label,
.range > div{
  margin: 0;
}

.range input {
  min-width: 70px;
}

.trigger-options > div > select{
  max-width: 320px;
}

.config-list.selected{
  font-weight: 600;
  color: #ff5f00 !important;
  background-color: #00A39F10;
  border: 2px solid #00A39F10;
}

.remove-config{
  z-index: 5;
}
@media (min-height: 770px) {
  .container-trigger{
    height: 76.6vh;
  }
}


</style>

<style>

.container-trigger .configured-trigger>div{
  overflow-y: auto;
  max-height: 155px;
}

.container-trigger .configured-trigger>div:first-child,
.container-trigger .configured-trigger>div:last-child>a{
  padding: 5px 8px;
}

.btn-add-configuration{
  width: 100%;
}

.no-content{
  margin-left: 5px;
  font-size: 0.7rem;
}

</style>